import React from 'react';
import { Button } from "./../../ui/ot"; // Adjust the import path based on your project structure

const NoPermission = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-white">
            <div className="text-6xl text-blue-500 mb-4">😟</div>
            <h1 className="text-xl font-bold mb-2">很抱歉 您沒有進入此介面的權限</h1>
            <Button className="bg-red-500 text-white px-4 py-2 mt-4" onClick={() => window.location.href = '/'}>
                返回首頁
            </Button>
        </div>
    );
}

export default NoPermission;